import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VyrobceDisku = {
	name: NAME,
	apiProvider,
	router,
};
